import React, { useEffect, useCallback } from 'react';
import { ReportContainer, Select, RadioGroup, Graph, StickyTable, AutoComplete, Icon } from 'components';
import { useReport } from 'store/report';
import { useSetState } from 'utils/hooks/useSetState';
import { useModal } from 'utils/hooks/useModal';
import { SELECTLIST, RADIOLIST } from 'constants/index';
import { useFormatterReport } from 'utils/hooks/useFormatterReport';

import { UiGraphRemind } from './DiscriminationOfAllSubjects.style';

/**
 * 全科試卷鑑別度
 */

// eslint-disable-next-line max-len
const alertStr = '<table> <thead> <tr> <td>鑑別指數</td> <td>題目評鑑</td> </tr> </thead> <tbody> <tr> <td>0.4以上</td> <td>非常優良</td> </tr> <tr> <td>0.3~0.39</td> <td>優良試題</td> </tr> <tr> <td>0.2~0.29</td> <td>尚可試題</td> </tr> <tr> <td>0.19以下</td> <td>待修改試題</td> </tr> </tbody> </table>';

export const DiscriminationOfAllSubjects = () => {

  const {
    formatterGraphData,
    formatterTableData,
  } = useFormatterReport();
  const { setModal } = useModal();
  const [{
    educationSelected,
    schoolYear,
    examType,
    grade,
    group,
    remind,
  }, setState] = useSetState({
    educationSelected: '',
    schoolYear: '',
    examType: '',
    grade: '',
    group: '',
    remind: '',
  });

  const [{
    selections,
    discrimination
  }, {
    getReportSeletions,
    getDiscrimination,
  }] = useReport();

  const onChangeSchool = value => {
    setState({
      group: value.school,
      schoolName: value.schoolName
    });
  };

  const onChangeHandler = value => {
    setState({
      ...value
    });
  };

  const selectGroup = useCallback(() => {
    if (Object.entries(selections).length === 0) return (<div>Loading...</div>);
    const {
      education,
      schoolYear: schoolYearOptions,
      grade: gradeOptions,
      examType: examTypeOptions,
    } = selections;
    //縣籍
    if (education) {
      return (
        <>
          <Select
            label={SELECTLIST.EDUCATION.label}
            options={education}
            selectName="educationSelected"
            onChange={onChangeHandler}
          />
          <Select
            label={SELECTLIST.SCHOOLYEAR.countyLabel}
            options={schoolYearOptions}
            selectName="schoolYear"
            onChange={onChangeHandler}
          />
          <Select
            label={SELECTLIST.EXAMTYPE.label}
            options={examTypeOptions}
            selectName="examType"
            onChange={onChangeHandler}
          />
        </>
      );
    }
    if (gradeOptions) {
      return (
        <>
          <Select
            label={SELECTLIST.SCHOOLYEAR.countyLabel}
            options={schoolYearOptions}
            selectName="schoolYear"
            onChange={onChangeHandler}
          />
          <Select
            label={SELECTLIST.GRADE.label}
            options={gradeOptions}
            selectName="grade"
            onChange={onChangeHandler}
          />
          <Select
            label={SELECTLIST.EXAMTYPE.label}
            options={examTypeOptions}
            selectName="examType"
            onChange={onChangeHandler}
          />
        </>
      );
    }
    if (examTypeOptions && schoolYearOptions) {
      return (
        <>
          <Select
            label={SELECTLIST.SCHOOLYEAR.countyLabel}
            options={schoolYearOptions}
            selectName="schoolYear"
            onChange={onChangeHandler}
          />
          <Select
            label={SELECTLIST.EXAMTYPE.label}
            options={examTypeOptions}
            selectName="examType"
            onChange={onChangeHandler}
          />
        </>
      );
    }
    return (
      <div>Loading...</div>
    );
  }, [selections]);

  const filterGroup = () => {
    const { education, } = selections;
    const { schoolName, className: groupList } = discrimination;
    if (education) {
      if (Object.keys(schoolName).length === 0) return;
      const schoolOptions = Object.entries(schoolName).map(([key, value]) => {
        return {
          name: value,
          value: key
        };
      });
      return (
        <AutoComplete
          list={schoolOptions}
          label="選擇學校"
          name="school"
          onChange={onChangeSchool}
        />
      );
    }
    if (groupList && Object.entries(groupList).length > 0) {
      if (typeof (groupList) === 'string') return null;
      const nextGroupList = Object.entries(groupList).map(([key, value]) => {
        return {
          name: value,
          value: key
        };
      });
      return (
        <RadioGroup
          name="group"
          data={nextGroupList}
          onChange={onChangeHandler}
          label={RADIOLIST.CLASS.label}
        />
      );
    }
    return null;
  };



  const dataGroup = useCallback(() => {
    const { education } = selections;
    if (Object.keys(discrimination.title).length === 0) return null;
    if (group === '') return;
    let reportTypeString = '';
    let reportRoleString = '';
    let groupList = {};
    const { title, schoolName, className, dataList } = discrimination;
    if (education) {
      reportTypeString = '鑑別度';
      reportRoleString = '全縣';
      groupList = schoolName;
    } else if (className) {
      reportTypeString = '鑑別度';
      reportRoleString = '全校';
      groupList = className;
    }
    const formatData = {
      reportData: discrimination,
      title,
      groupList,
      dataList,
      reportTypeString,
      reportRoleString,
      group
    };
    const { data, pv, uv } = formatterGraphData(formatData);
    const nextTableData = formatterTableData({
      ...formatData,
      groupName: education ? '學校' : '班級'
    });
    return (
      <>
        <Graph.BarLine data={data} pv={pv} uv={uv} />
        <UiGraphRemind
          onClick={() => {
            setModal({
              title: '鑑別度提示',
              html: alertStr,
              showCancelButton: false,
              confirmEvent: () => { },
            });
          }}
        >
          <Icon name='error' color='#f00' />鑑別度提示
      </UiGraphRemind>
        <StickyTable.FixedTitle
          schema={nextTableData.tableSchema}
          data={nextTableData.data}
        />
      </>
    );
  }, [group, discrimination.title]);

  const teacherDataGroup = useCallback(() => {
    if (Object.keys(discrimination.classDiscrimination).length === 0) return null;
    const { classDiscrimination, schoolDiscrimination, header, className } = discrimination;
    const tableSchema = ['', ...header.map(item => item.name)];
    const allSubjectRate = [];
    const classSUbjectRate = [];
    const graphData = [];
    const uv = className;
    const pv = '全校鑑別度';

    header.forEach(item => {
      const allSubjectValue = schoolDiscrimination[item.value];
      const classSubjectValue = classDiscrimination[item.value];
      allSubjectRate.push(`${allSubjectValue}%`);
      classSUbjectRate.push(`${classSubjectValue}%`);
      graphData.push({
        name: item.name,
        [uv]: classSubjectValue,
        [pv]: allSubjectValue,
      });
    });

    const newTableData = [
      {
        catelogey: '全校全科試卷鑑別度',
        list: allSubjectRate
      },
      {
        catelogey: className,
        list: classSUbjectRate
      }
    ];
    return (
      <>
        <Graph.BarLine data={graphData} pv={pv} uv={uv} />
        <UiGraphRemind
          onClick={() => {
            setModal({
              title: '鑑別度提示',
              html: alertStr,
              showCancelButton: false,
              confirmEvent: () => { },
            });
          }}
        >
          <Icon name='error' color='#f00' />鑑別度提示
      </UiGraphRemind>
        <StickyTable.FixedTitle schema={tableSchema} data={newTableData} headerCount={1} canSort={false} />
      </>
    );
  }, [discrimination.classDiscrimination]);

  useEffect(() => {
    const payload = {
      reportType: 'Difficulty'
    };
    getReportSeletions(payload);
  }, []);

  useEffect(() => {
    const { education, grade: gradeOptions } = selections;
    if (education) {
      setState({
        remind: '※ 點選學校名稱會以藍色折線圖呈現於圖表'
      });
      if (educationSelected && schoolYear && examType) {
        const payload = {
          education: educationSelected,
          schoolYear,
          examType,
        };
        getDiscrimination(payload);
      }
    } else if (gradeOptions) {
      setState({
        remind: '※ 點選班級名稱會以藍色折線圖呈現於圖表'
      });
      if (schoolYear && examType && grade) {
        const payload = {
          grade,
          schoolYear,
          examType,
        };
        getDiscrimination(payload);
      }
    } else {
      setState({
        remind: '※ 點選學生名稱會以藍色折線圖呈現於圖表'
      });
      if (schoolYear && examType) {
        const payload = {
          schoolYear,
          examType,
        };
        getDiscrimination(payload);
      }
    }
  }, [educationSelected, schoolYear, examType, group]);

  return (
    <ReportContainer
      title="全科試卷鑑別度"
      remind={remind}
      selectGroup={selectGroup()}
      radioChildren={filterGroup()}
    >
      {Object.keys(discrimination.title).length > 0 && dataGroup()}
      {Object.keys(discrimination.classDiscrimination).length > 0 && teacherDataGroup()}
    </ReportContainer>
  );
};
